import type { BridgeMcpToolCallResult, BridgeMcpToolContext } from '../../../bridge-mcp-tool-types.js';
import { resolveParentSessionIdForChild } from '../cloud/resolve-parent-session-id.js';
import { callGetParentSessionTurnTranscriptTool } from './call-get-parent-session-turn-transcript.js';
import { callListParentSessionPromptsTool } from './call-list-parent-session-prompts.js';
import { mcpTextResult } from './mcp-text-result.js';
import { GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL, LIST_PARENT_SESSION_PROMPTS_TOOL } from './tool-names.js';

export async function callForkSessionMcpTool(
  ctx: BridgeMcpToolContext,
  cloud: { cloudApiBaseUrl: string; getCloudAccessToken: () => string },
  name: string,
  args: Record<string, unknown>,
): Promise<BridgeMcpToolCallResult> {
  const childSessionId = ctx.sessionId.trim();
  if (!childSessionId) {
    return mcpTextResult('sessionId is required.', true);
  }

  const parentResolved = await resolveParentSessionIdForChild({
    childSessionId,
    cloudApiBaseUrl: cloud.cloudApiBaseUrl,
    getCloudAccessToken: cloud.getCloudAccessToken,
  });
  if (!parentResolved.ok) {
    return mcpTextResult(parentResolved.error, true);
  }
  const parentSessionId = parentResolved.parentSessionId;

  if (name === LIST_PARENT_SESSION_PROMPTS_TOOL) {
    return callListParentSessionPromptsTool(ctx, cloud, childSessionId, parentSessionId);
  }

  if (name === GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL) {
    return callGetParentSessionTurnTranscriptTool(ctx, cloud, childSessionId, args);
  }

  return mcpTextResult(`Unknown fork session tool: ${name}`, true);
}
